import Vue from 'vue';
import VueRouter from 'vue-router';
import RouterViewIndex from '@/views/RouterViewIndex.vue';
import i18n from '@/i18n/index.js';
Vue.use(VueRouter);

export default [
  {
    path: 'exam-list/:pagination',
    name: 'exam-list-index',
    component: RouterViewIndex,
    redirect: {
      name: 'exam-list',
      params: {
        pagination: 1,
      },
    },
    meta: {
      title: i18n.t('報名檢定'),
    },
    children: [
      {
        path: '',
        name: 'exam-list',
        query: {
          keyword: '',
        },
        params: {
          pagination: 1,
        },
        meta: {
          title: i18n.t('報名檢定'),
          isExam: true,
        },
        component: () => import('@/views/Event/EventList.vue'),
      },
      {
        path: 'exam-information/:id',
        name: 'examInformation-index',
        component: RouterViewIndex,
        redirect: {
          name: 'examInformation',
        },
        meta: {
          key: 'examInformation',
          title: i18n.t('檢定內頁'),
        },
        children: [
          {
            path: '',
            name: 'examInformation',
            component: () => import('@/views/Event/Event.vue'),
            meta: {
              isExam: true,
              key: 'examInformation',
              title: i18n.t('檢定內頁'),
            },
          },
          {
            path: 'exam-sign-up',
            name: 'examSignUp-index',
            component: RouterViewIndex,
            redirect: {
              name: 'examSignUp',
            },
            children: [
              {
                path: '',
                name: 'examSignUp',
                component: () => import('@/views/Event/EventSignUp.vue'),
                meta: {
                  key: 'signUp',
                  title: i18n.t('報名檢定'),
                  requireAuth: true,
                  requireMobile: true,
                  isExam: true,
                },
              },
            ],
          },
          {
            path: 'exam-sign-up-result/:paymentId',
            name: 'exam-signU-up-result-index',
            component: RouterViewIndex,
            redirect: {
              name: 'examSignUp',
            },
            children: [
              {
                path: '',
                name: 'exam-signU-up-result',
                component: () => import('@/views/Event/SignUpResult.vue'),
                meta: {
                  title: i18n.t('報名成功'),
                  requireAuth: true,
                  requireMobile: true,
                  isExam: true,
                },
              },
            ],
          },
        ],
      },
      {
        path: 'exam',
        name: 'exam-index',
        component: RouterViewIndex,
        redirect: {
          name: 'exam',
        },
        meta: {
          key: 'exam',
          title: i18n.t('完成檢定'),
          requireAuth: true,
          requireMobile: true,
        },
        children: [
          {
            path: '',
            name: 'exam',
            component: () => import('@/views/Exam/Exam.vue'),
          },
          {
            path: 'exam-room',
            name: 'exam-room',
            component: () => import('@/views/Exam/ExamRoom.vue'),
            meta: {
              title: i18n.t('檢定進行中'),
              key: 'examRoom',
              requireAuth: true,
              requireMobile: true,
            },
          },
        ],
      },
    ],
  },
];
